import React from 'react';
import { ServiceSelect } from "../../features/ServiceSelect";
import styled from "styled-components";

const KcellRoot = styled.div`
    margin-top: 120px;
    h1 {
        margin-bottom: 25px;
				text-align: start;
    }
    @media screen and (max-width: 640px) {
        margin-top: 20px;
    }
`

const Kcell = ({ lang }) => {
	return (
		<KcellRoot>
			<ServiceSelect type="kcell" lang={lang}/>
		</KcellRoot>
	);
};

export default Kcell;
